// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_s2yaR","title":"title_dTFB5","list":"list_2aftJ","item":"item_3Kq4T","itemTitle":"itemTitle_2ntfD","itemDesc":"itemDesc_2RAw6","check":"check_2TaLd"};